
import Vue from 'vue';
import DialogOrBottomSheet from '@/components/base/DialogOrBottomSheet.vue';
import DialogContent from '@/components/base/DialogContent.vue';

interface ShortcutRow {
	keys: string[]
	what: string
}

interface ShortcutGroup {
	title: string
	rows: ShortcutRow[]
}

// Every shortcut on the Feedback admin page, in one place: the ? key or the header's Shortcuts
// button opens it. AdminFeedback.onKey, FeedbackComments, FeedbackStatusDialog and
// FeedbackShotViewer handle the keys themselves: keep this list in step with them.
export default Vue.extend({
	name: 'FeedbackShortcuts',
	props: {
		value: { type: Boolean, default: false },
	},
	computed: {
		groups (): ShortcutGroup[] {
			const send: string = /Mac|iPhone|iPad/.test(navigator.platform || '') ? '⌘' : 'Ctrl';
			return [
				{
					title: 'Moving around',
					rows: [
						{ keys: ['J'], what: 'Next report' },
						{ keys: ['K'], what: 'Previous report (hold J or K to keep going)' },
						{ keys: ['/'], what: 'Search' },
						{ keys: ['?'], what: 'These shortcuts' },
					],
				},
				{
					title: 'The open report',
					rows: [
						{ keys: ['A'], what: 'Make it ready for an agent, when nobody has yet. The next report opens.' },
						{ keys: ['C'], what: 'Write a comment' },
					],
				},
				{
					title: 'Writing a comment, reply, edit or note',
					rows: [
						{ keys: [send, 'Enter'], what: 'Send it, or save the edit' },
						{ keys: ['Esc'], what: 'Cancel a reply, an edit or a note' },
					],
				},
				{
					title: 'A screenshot open full size',
					rows: [
						{ keys: ['←', '→'], what: 'Previous and next screenshot' },
						{ keys: ['Esc'], what: 'Close it' },
					],
				},
			];
		},
	},
	components: {
		DialogContent,
		DialogOrBottomSheet,
	},
});
